import React, { useMemo } from "react"
import { graphql, useStaticQuery } from "gatsby"

import CtaSmallWithIcon from "./CtaSmallWithIcon"
import CtaLargeWithImage from "./CtaLargeWithImage"
import CtaLargeNoImage from "./CtaLargeNoImage"

type PostInlineCtaProps = {
  "data-slug": string
  "data-variant": string
}

const PostInlineCta: React.FC<PostInlineCtaProps> = ({ ...props }) => {
  const { posts } = useStaticQuery(graphql`
    query {
      posts: allGhostPost(filter: { primary_tag: { slug: { eq: "cta" } } }) {
        edges {
          node {
            id
            title
            slug
            feature_image
            og_image
            childHtmlRehype {
              htmlAst
            }
          }
        }
      }
    }
  `)

  const cta = useMemo(() => {
    return posts.edges.find(({ node }) => node.slug === props?.["data-slug"])
  }, [posts?.edges, props?.['data-slug']])

  if (!cta) {
    return null
  }

  switch (props?.["data-variant"]) {
    case "small":
      return <CtaSmallWithIcon cta={cta} />
    case "large-with-image":
      return <CtaLargeWithImage cta={cta} />
    case "large-no-image":
      return <CtaLargeNoImage cta={cta} />
    default:
      return null
  }
}

export default PostInlineCta
